var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChefHatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41811 5.92442L5.21649 6.13835L4.28948 9.598L5.35399 9.88323L6.281 6.42358L7.07938 6.63751L6.15237 10.0972L8.01526 10.5963L8.87488 7.38818C10.1079 7.57668 11.3114 6.81096 11.6418 5.57812C11.9962 4.25532 11.2112 2.89564 9.88839 2.5412C9.63429 2.47311 9.37883 2.44707 9.12939 2.45881C8.98885 1.51082 8.30219 0.690007 7.31754 0.426171C6.33289 0.162335 5.32781 0.52985 4.7321 1.28056C4.52196 1.14568 4.2877 1.0405 4.0336 0.972412C2.7108 0.61797 1.35112 1.40298 0.996676 2.72578C0.666336 3.95862 1.32575 5.22351 2.48783 5.67677L1.62821 8.88492L3.4911 9.38408L4.41811 5.92442Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4856 9.41717L1.12905 10.7478L7.5161 12.4592L7.87265 11.1286L1.4856 9.41717Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHatWhite);
export default __webpack_public_path__ + "static/media/chefHat_white.169738c6.svg";
export { ForwardRef as ReactComponent };